import { Component, type ComponentChildren } from "preact";
import { reportError } from "../state/telemetry";

/** Keeps one broken view from blanking the whole app. */
export class ErrorBoundary extends Component<{ children: ComponentChildren; label: string }, { error: Error | null }> {
  state = { error: null as Error | null };

  componentDidCatch(error: Error) {
    console.error(error);
    reportError(this.props.label, error);
    this.setState({ error });
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div class="crash" role="alert">
        <h2>Something went wrong in {this.props.label}</h2>
        <p>Your swipes are safe. Try again, or reload the app if it keeps happening.</p>
        <div class="row-gap">
          <button class="btn" onClick={() => this.setState({ error: null })}>
            Try again
          </button>
          <button class="btn btn-primary" onClick={() => location.reload()}>
            Reload
          </button>
        </div>
      </div>
    );
  }
}
